import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDataTable, {
    staticClass: "elevation-1",
    attrs: {
      headers: _vm.headers,
      items: _vm.parentItem.quantitiesForOrders,
      "item-key": "orderId",
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c(VToolbar, {
          attrs: {
            flat: ""
          }
        }, [_c(VToolbarTitle, [_vm._v("Quantity order details")]), _c(VDivider, {
          staticClass: "mx-4",
          attrs: {
            inset: "",
            vertical: ""
          }
        }), _c(VSpacer), _c(VDialog, {
          attrs: {
            persistent: "",
            "max-width": "950"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c(VBtn, _vm._g(_vm._b({
                staticClass: "mb-2",
                attrs: {
                  disabled: _vm.disabled || !_vm.ordersStillFillable.length
                }
              }, "v-btn", attrs, false), on), [_vm._v(" + ")])];
            }
          }]),
          model: {
            value: _vm.dialog,
            callback: function callback($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog"
          }
        }, [_c(VCard, [_c("div", {
          staticClass: "dialog-closer"
        }, [_c(VIcon, {
          staticClass: "far fa-times-circle",
          on: {
            click: _vm.close
          }
        })], 1), _c(VForm, {
          staticClass: "form text-left",
          model: {
            value: _vm.form.valid,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "valid", $$v);
            },
            expression: "form.valid"
          }
        }, [_c(VCardTitle, [_c("span", {
          staticClass: "text-h5"
        }, [_vm._v(_vm._s(_vm.formTitle))])]), _c(VCardText, [_c(VContainer, [_c(VRow, [_c(VCol, {
          attrs: {
            cols: "12",
            "align-self": "center"
          }
        }, [_c(VRow, [_vm.isAttachedToNotCompatibleOrder ? [_c("div", {
          staticClass: "errorLabel"
        }, [_vm._v(" The order status associated seems to be not compatible with quantity edition ")])] : [_c(VCol, {
          attrs: {
            cols: "12",
            md: "6"
          }
        }, [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            disabled: _vm.editedItem.isBeingEdited || _vm.ordersStillFillable.length < 1,
            items: _vm.editedItem.isBeingEdited ? _vm.ordersFillable : _vm.ordersStillFillable,
            "item-text": "_searchable_name",
            "item-value": "orderId",
            placeholder: "Select an order",
            label: "Order",
            "hide-details": "auto",
            "hide-selected": "",
            required: "",
            rules: [_vm.rules.mustSelectValue],
            filter: _vm.filterVAutocomplete
          },
          on: {
            change: _vm.changeOrder
          },
          model: {
            value: _vm.editedItem.orderId,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "orderId", $$v);
            },
            expression: "editedItem.orderId"
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12",
            md: "6"
          }
        }, [_c(VTextField, {
          staticClass: "required",
          attrs: {
            type: "number",
            label: "Quantity (bottles)",
            min: "0",
            max: _vm.maxAllowed,
            required: "",
            rules: [_vm.rules.mustBeGreaterThan0],
            "hide-details": "auto"
          },
          on: {
            change: _vm.changeQuantity
          },
          model: {
            value: _vm.editedItem.quantity,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "quantity", $$v);
            },
            expression: "editedItem.quantity"
          }
        })], 1)]], 2)], 1)], 1)], 1)], 1), _c(VCardActions, [_c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.close
          }
        }, [_vm._v("Cancel")]), !_vm.isAttachedToNotCompatibleOrder ? _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: "",
            disabled: !_vm.form.valid,
            text: ""
          },
          on: {
            click: _vm.save
          }
        }, [_vm._v(" Save ")]) : _vm._e()], 1)], 1)], 1)], 1), _c(VDialog, {
          attrs: {
            "max-width": "500px"
          },
          model: {
            value: _vm.dialogDelete,
            callback: function callback($$v) {
              _vm.dialogDelete = $$v;
            },
            expression: "dialogDelete"
          }
        }, [_c(VCard, [_c(VToolbar, {
          attrs: {
            color: "primary",
            dense: "",
            flat: ""
          }
        }, [_c(VToolbarTitle, {
          staticClass: "dialog-title"
        }, [_vm._v("Confirm")])], 1), _c(VCardText, {
          staticClass: "pa-4 dialog-message"
        }, [_vm._v(" Are you sure you want to delete this item ? ")]), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.closeDelete
          }
        }, [_vm._v("No")]), _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.deleteItemConfirm
          }
        }, [_vm._v("Yes")]), _c(VSpacer)], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, !_vm.disabled ? {
      key: "item.actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.editItem(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c(VIcon, {
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(item);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    } : null], null, true)
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };